import React from "react";
import { Provider } from "react-redux";
import Routes from "sc/ui/sites/oncall/Routes";
import { PersistGate } from "redux-persist/integration/react";
import "./App.css";
import { Router } from "../../../Router";

import * as eventLevels from "react-big-calendar/lib/utils/eventLevels";
import moment from "moment";

// ATTENTION: Ugly hack
// react-big-calendar shows:
// events spanning multiple days go first
// then allDay single day events
// then sort by start time
// We want to directly sort by start time, but they react-big-calendar doesn't provide any customization
// So we're just overriding their sort method.
// This also makes startAccessor unusable, change the code here if you want to use it again.
// Here is the original source code: https://github.com/intljusticemission/react-big-calendar/blob/6bced685f6edd27b7604d1ddb7936b8e1af95973/src/utils/eventLevels.js
eventLevels.sortEvents = (evtA, evtB) => moment(evtA.start).diff(evtB.start);

export const App = ({ config }) => (
  <PersistGate loading={null} persistor={config.persistor}>
    <Provider store={config.store}>
      <Router history={config.history} Routes={Routes} />
    </Provider>
  </PersistGate>
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/App.js